import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import MainLayout from "../Layouts/main";
import InternalLink from "../components/InternalLink";
import SkillFilters from "./SkillFilters";
import SkillCard from "./SkillCard";
import IntegrationSkillsSection from "./IntegrationSkillsSection";
import SkillRequestsSection from "./SkillRequestsSection";
import { SKILLS_AVAILABLE } from "./skillsData";

// Re-export for backward compatibility
export { SKILLS_AVAILABLE } from "./skillsData";

function Skills() {
    const { t } = useTranslation();
    const [activeFilter, setActiveFilter] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");

    const filteredSkills = useMemo(() => {
        return SKILLS_AVAILABLE.filter((skill) => {
            const matchesSearch =
                !searchQuery ||
                skill.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                t(skill.descriptionKey).toLowerCase().includes(searchQuery.toLowerCase());

            if (!matchesSearch) return false;
            if (activeFilter === "all") return skill.category !== "components";
            if (activeFilter === "new") return skill.isNew;
            return skill.category === activeFilter;
        });
    }, [activeFilter, searchQuery, t]);

    return (
        <MainLayout>
            <div className="space-y-6 max-w-5xl mx-auto">
                <div className="flex items-center justify-between">
                    <div className="space-y-1">
                        <h1 className="page-title">{t("skillsPage.title")}</h1>
                        <p className="text-sm text-gray-500">{t("skillsPage.subtitle")}</p>
                    </div>
                    <InternalLink to="/integrate" className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap">
                        {t("skillsPage.connectedApps")}
                    </InternalLink>
                </div>

                <SkillRequestsSection />

                <SkillFilters
                    activeFilter={activeFilter}
                    onFilterChange={setActiveFilter}
                    searchQuery={searchQuery}
                    onSearchChange={setSearchQuery}
                />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {filteredSkills.map((skill) => (
                        <SkillCard key={skill.id} skill={skill} />
                    ))}
                </div>

                {filteredSkills.length === 0 && (
                    <div className="text-center py-12 text-gray-400">
                        <p className="text-lg">{t("skillsPage.noResults")}</p>
                    </div>
                )}

                <IntegrationSkillsSection />
            </div>
        </MainLayout>
    );
}

export default Skills;
